import { WorkOrder } from "../../@types/WorkOrder";
import { getListBySite } from "./api";

export function getEditState(inEditMode: boolean, workOrderToEdit: WorkOrder) {
    return inEditMode
      ? {
          createdDateTime: new Date(
            workOrderToEdit.createdDateTime,
          ).toISOString(),
          ...workOrderToEdit,
        }
      : null;
  }
  
export function getCreateState(siteId: string, userId: string ) {
    return {
        siteId,
        communityId: null,
        buildingId: null,
        unitId: null,
  
        siteName: null,
        communityName: null,
        buildingName: null,
        locationUnitDisplay: null,
  
        status: 'Pending',
        type: null,
        priority: null,
        longitude: 0,
        latitude: 0,
        shortDescription: null,
        description: null,
        shortLocation: null,
        location: null,
        locationIsAunit: true,
        pictureImage: null,
        pictureImageLink: null,
  
        assignedToName: null,
        assignedToId: null,
        closedImage: null,
        closedPictureImageLink: null,
        createdByAUnit: true,
        createdById: userId,
        createdByName: null,
        createdByType: null,
        createdDateTime: null,
  
        paidInFull: true,
        amountPaid: null,
        workOrdersCosts: [
        ],
    };
  }


export async function fetchListBySite(
  field: string,
  siteId: string,
  module: string,
) {
  try {
    let response = await getListBySite(1, siteId);

    let sitesResponse = await response.filter(
      responseItem => responseItem.tableName === module,
    );

    const res = sitesResponse.filter(
      listBySiteItem => listBySiteItem.field === field,
    );
    let options = [];

    res.forEach(element => {
      if (element.options.includes(',')) {
        const subOptionsArr = element.options.split(',');
        options = [...options, ...subOptionsArr];
      } else {
        options = [...options, element.options];
      }
    });
    return options;
  } catch (err) {
    throw new Error(err.message);
  }
}
